import { Trans } from '@lingui/react';
import { GqlCurrency } from '../graphql/base-types.graphql';
import { type ReactNode } from 'react';

export const currenciesShort: { name: ReactNode; code: GqlCurrency }[] = [
  { name: <Trans id="Swedish Krona" />, code: GqlCurrency.Sek },
  { name: 'Euro', code: GqlCurrency.Eur },
  { name: <Trans id="US Dollar" />, code: GqlCurrency.Usd },
  { name: <Trans id="British Pound" />, code: GqlCurrency.Gbp },
];

export const currencies: { name: ReactNode; code: GqlCurrency }[] = [
  ...currenciesShort,
  { name: <Trans id="Argentine Peso" />, code: GqlCurrency.Ars },
  { name: <Trans id="Australian Dollar" />, code: GqlCurrency.Aud },
  { name: <Trans id="Brazilian Real" />, code: GqlCurrency.Brl },
  { name: <Trans id="Canadian Dollar" />, code: GqlCurrency.Cad },
  { name: <Trans id="Chilean Peso" />, code: GqlCurrency.Clp },
  { name: <Trans id="Colombian Peso" />, code: GqlCurrency.Cop },
  { name: <Trans id="Croatian Kuna" />, code: GqlCurrency.Hrk },
  { name: <Trans id="Czech Koruna" />, code: GqlCurrency.Czk },
  { name: <Trans id="Egyptian Pound" />, code: GqlCurrency.Egp },
  { name: <Trans id="Hong Kong Dollar" />, code: GqlCurrency.Hkd },
  { name: <Trans id="Hungarian Forint" />, code: GqlCurrency.Huf },
  { name: <Trans id="Icelandic Krona" />, code: GqlCurrency.Isk },
  { name: <Trans id="Indian Rupee" />, code: GqlCurrency.Inr },
  { name: <Trans id="Indonesian Rupiah" />, code: GqlCurrency.Idr },
  { name: <Trans id="Israeli New Shekel" />, code: GqlCurrency.Ils },
  { name: <Trans id="Jamaican Dollar" />, code: GqlCurrency.Jmd },
  { name: <Trans id="Japanese Yen" />, code: GqlCurrency.Jpy },
  { name: <Trans id="Malaysian Ringgit" />, code: GqlCurrency.Myr },
  { name: <Trans id="Mexican Peso" />, code: GqlCurrency.Mxn },
  { name: <Trans id="New Taiwan Dollar" />, code: GqlCurrency.Twd },
  { name: <Trans id="New Zealand Dollar" />, code: GqlCurrency.Nzd },
  { name: <Trans id="Nigerian Naira" />, code: GqlCurrency.Ngn },
  { name: <Trans id="Norwegian Krone" />, code: GqlCurrency.Nok },
  { name: <Trans id="Pakistani Rupee" />, code: GqlCurrency.Pkr },
  { name: <Trans id="Peruvian Sol" />, code: GqlCurrency.Pen },
  { name: <Trans id="Philippine Peso" />, code: GqlCurrency.Php },
  { name: <Trans id="Polish Zloty" />, code: GqlCurrency.Pln },
  { name: <Trans id="Qatari Rial" />, code: GqlCurrency.Qar },
  { name: <Trans id="Renminbi" />, code: GqlCurrency.Cny },
  { name: <Trans id="Romanian Leu" />, code: GqlCurrency.Ron },
  { name: <Trans id="Russian Ruble" />, code: GqlCurrency.Rub },
  { name: <Trans id="Saudi Riyal" />, code: GqlCurrency.Sar },
  { name: <Trans id="Singapore Dollar" />, code: GqlCurrency.Sgd },
  { name: <Trans id="South African Rand" />, code: GqlCurrency.Zar },
  { name: <Trans id="South Korean Won" />, code: GqlCurrency.Krw },
  { name: <Trans id="Swiss Franc" />, code: GqlCurrency.Chf },
  { name: <Trans id="Thai Baht" />, code: GqlCurrency.Thb },
  { name: <Trans id="Turkish Lira" />, code: GqlCurrency.Try },
  { name: <Trans id="Ukrainian Hryvnia" />, code: GqlCurrency.Uah },
  { name: <Trans id="Vietnamese Dong" />, code: GqlCurrency.Vnd },
];
